import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ApiService,
  CommonFunctionsService,
  DatastoreService,
  resolvePurchasedAddOns,
} from '../../services';

@Component({
  selector: 'app-my-add-ons',
  templateUrl: './my-add-ons.component.html',
  styleUrls: ['./my-add-ons.component.scss'],
})
export class MyAddOnsComponent implements OnInit {
  site = '';
  company: any;
  service: any;
  booking: any;

  /** Add-on rows to display: { item, quantity }. */
  addOns: Array<{ item: string; quantity: number }> = [];

  constructor(
    private route: ActivatedRoute,
    private dataStore: DatastoreService,
    private commonFunctionsService: CommonFunctionsService,
    private apiService: ApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe(async (params) => {
      await this.commonFunctionsService.setCompanyName(params);
      this.site = params.site;
    });

    this.company = this.dataStore.selectedCompany;
    if (!this.company) {
      this.company = JSON.parse(localStorage.getItem('company') as string);
    }

    this.service = this.dataStore.selectedService;
    if (!this.service) {
      this.service = JSON.parse(localStorage.getItem('service') as string);
    }

    this.booking = this.dataStore.booking;
    if (!this.booking) {
      this.booking = JSON.parse(localStorage.getItem('ceremony') as string);
    }

    this.setup();
  }

  async setup() {
    try {
      // The extra-item links attached to this booking (what the customer has).
      const links = (await this.apiService.getServiceItemExtraLinksForBooking(
        this.booking.company_id,
        this.booking.id
      )) as any;

      if (!Array.isArray(links) || links.length === 0) {
        this.addOns = [];
        return;
      }

      // The service's extra items (including hidden) so we can resolve each
      // link's item_description by item_id — the confident way to filter fees.
      let serviceExtraItems: any[] = [];
      try {
        serviceExtraItems = await this.apiService
          .getServiceItemExtras(
            this.booking.company_id,
            this.service.global_id,
            null,
            true
          )
          .toPromise();
      } catch (err) {
        console.error('Failed to fetch service extra items', err);
      }

      this.addOns = resolvePurchasedAddOns(links, serviceExtraItems).map(
        ({ item, quantity }) => ({ item, quantity })
      );
    } catch (err) {
      console.error('Failed to load add-ons', err);
      this.addOns = [];
    }
  }

  navigate(route: string) {
		this.router.navigate([
			`${this.commonFunctionsService.getCompanyName()}/${this.commonFunctionsService.getCompanyId()}${route}`,
		]);
	}
}
